import { Link } from 'react-router-dom';
import { mangas } from '@/mocks/mangas';
import MangaCard from '@/components/feature/MangaCard';

export default function FeaturedManga() {
  const featured = mangas.filter((m) => m.featured);

  return (
    <section className="py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
              热门推荐
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              为你精选最值得追的漫画佳作
            </p>
          </div>
          <Link to="/category/riman" className="text-sm text-primary-500 hover:text-primary-600 font-medium flex items-center gap-1 whitespace-nowrap cursor-pointer">
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6" data-product-shop="">
          {featured.map((manga) => (
            <MangaCard key={manga.id} manga={manga} />
          ))}
        </div>
      </div>
    </section>
  );
}